import React from "react";
import SVGandTextContainer from "./SVGandTextContainer";
import { helpdeskHelp } from "@/components/icons/SVGIcons";
import SidebarHeading from "./SidebarHeading";
import { Button } from "@/components/UI/Button";

const HelpdeskButton = ({
  toolbarOpen,
  onClick,
}: {
  toolbarOpen: boolean;
  onClick: () => void;
}) => {
  return (
    <div>
      {toolbarOpen && <SidebarHeading heading={"Support"} />}
      <div className={`${toolbarOpen ? "ml-1" : ""}`}>
        <Button variant="sidebarItem" id="HelpdeskButton" onClick={onClick}>
          <SVGandTextContainer
            tooltipID={"HelpdeskLink"}
            SVGIcon={helpdeskHelp}
            toolbarOpen={toolbarOpen}
            openText={"Email Helpdesk"}
          />
        </Button>
      </div>
    </div>
  );
};

export default HelpdeskButton;
